import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import BillingHeaderNav from "../../components/BillingHeaderNav";

import PlansList from "./PlansList";
import PlansPageHeader from "./PlansPageHeader";

const PlansPage = () => {
  const { t } = useTranslation("plans", { keyPrefix: "page.plansPage" });

  return (
    <Box sx={styles.root} component="main">
      <BillingHeaderNav />
      <PlansPageHeader />
      <PlansList />
      {/* <Box sx={styles.contactUsContainer}>
        <Box sx={styles.contactUsContent}>
          <Typography sx={styles.contactUsTitle}>{t("ifYouHaveAnyQuestions")}</Typography>
          <Typography sx={styles.contactUsDescription}>
            {t("cantFindTheAnswerYoureLookingForPleaseChatToOurFriendlyTeam")}
          </Typography>
        </Box>
        <Button sx={styles.contactUsButton} variant="outlined-md" disabled>
          {t("contactUs")}
        </Button>
      </Box> */}
    </Box>
  );
};

export default PlansPage;

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "100%",
  },
  contactUsContainer: {
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "12px",
    border: "1px solid var(--Gray-200, #E4E7EC)",
    background: "var(--Base-White, #FFF)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    padding: "24px",
  },
  contactUsContent: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  contactUsTitle: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  contactUsDescription: {
    fontFamily: "Montserrat",
    color: "var(--Gray-600, #475467)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  contactUsButton: {
    color: "var(--Gray-700, #344054) !important",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    padding: "10px 24px",
    borderRadius: "40px",
    border: "1px solid var(--Gray-300, #D0D5DD) !important",
    background: "var(--Base-White, #FFF) !important",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: "fit-content",
  },
};
